import React from 'react';
import HeroContent from './HeroContent';
import HeroImage from './HeroImage';

export default function VintageHero() {
  return (
    <section className="relative min-h-[90vh] bg-[#FDF6E9] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
        <div className="grid md:grid-cols-2 gap-8 items-center min-h-[90vh] py-20">
          <HeroContent />
          <HeroImage />
        </div>
      </div>
      
      {/* Vintage Pattern Overlay */}
      <div className="absolute inset-0 pointer-events-none opacity-5 vintage-overlay" />

      {/* Enhanced Bottom Transition */}
      <div className="absolute bottom-0 left-0 right-0">
        {/* Main Wave */}
        <svg
          className="w-full h-20 fill-white transform translate-y-1"
          viewBox="0 0 1440 96"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path 
            d="M0,96 L1440,96 L1440,0 C1380,20 1320,30 1260,20 C1200,10 1140,0 1080,10 C960,30 840,40 720,30 C600,20 480,0 360,10 C240,20 120,40 60,30 C30,25 0,15 0,0 L0,96 Z"
            className="opacity-20"
          />
          <path 
            d="M0,96 L1440,96 L1440,20 C1320,40 1200,30 1080,20 C960,10 840,20 720,40 C600,60 480,50 360,30 C240,10 120,20 60,30 C30,35 0,25 0,20 L0,96 Z"
            className="opacity-40"
          />
          <path 
            d="M0,96 L1440,96 L1440,40 C1380,60 1320,70 1260,60 C1200,50 1140,40 1080,50 C960,70 840,80 720,70 C600,60 480,40 360,50 C240,60 120,80 60,70 C30,65 0,55 0,40 L0,96 Z"
          />
        </svg>

        {/* Decorative Dots */}
        <div className="absolute bottom-0 left-0 right-0 h-20 flex justify-around items-end pb-4 pointer-events-none">
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="w-2 h-2 rounded-full bg-red-600/20"
              style={{
                transform: `translateY(${i % 2 ? '-8px' : '0'})`
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}